<div class="dtb" [class.dark]="isDark">

  <!-- Cursor -->
  <button class="dtb-btn" [class.dtb-active]="!activeTool" (click)="selectCursor()" title="Cursor (Esc)">
    <svg width="17" height="17" viewBox="0 0 16 16" fill="currentColor">
      <path d="M2 1l12 7-6 1.5L6 15 2 1z"/>
    </svg>
  </button>

  <div class="dtb-sep"></div>

  <!-- Grupos de herramientas -->
  <ng-container *ngFor="let group of groups">
    <div class="dtb-group" (mouseenter)="openFlyout(group.id)" (mouseleave)="scheduleCloseFlyout()">
      <button class="dtb-btn dtb-has-sub"
        [class.dtb-active]="isGroupActive(group)"
        (click)="selectGroup(group)"
        [title]="group.label">
        <i [ngClass]="groupIcon(group)"></i>
        <span class="dtb-arr"></span>
      </button>
      <div class="dtb-flyout" *ngIf="flyout === group.id"
           (mouseenter)="openFlyout(group.id)" (mouseleave)="scheduleCloseFlyout()">
        <div class="dtb-fly-header">{{ group.label }}</div>
        <button *ngFor="let tool of group.tools" class="dtb-fly-item"
          [class.dtb-fly-active]="activeTool === tool.type"
          (click)="selectTool(tool)">
          <i [ngClass]="tool.icon"></i>
          <span>{{ tool.label }}</span>
        </button>
      </div>
    </div>
  </ng-container>

  <div class="dtb-sep"></div>

  <!-- Imán -->
  <button class="dtb-btn" [class.dtb-active]="controller.magnetEnabled"
    (click)="controller.toggleMagnet()" title="Imán: pegar a OHLC">
    <i class="bi bi-magnet"></i>
  </button>

  <!-- Mantener modo dibujo -->
  <button class="dtb-btn" [class.dtb-active]="controller.stayInDrawingMode"
    (click)="controller.toggleStayInDrawingMode()" title="Permanecer en modo dibujo">
    <i class="bi bi-pencil-square"></i>
  </button>

  <div class="dtb-sep"></div>

  <!-- Undo / redo -->
  <button class="dtb-btn" [disabled]="!canUndo" (click)="controller.undo()" title="Deshacer (Ctrl+Z)">
    <i class="bi bi-arrow-counterclockwise"></i>
  </button>
  <button class="dtb-btn" [disabled]="!canRedo" (click)="controller.redo()" title="Rehacer (Ctrl+Y)">
    <i class="bi bi-arrow-clockwise"></i>
  </button>

  <div class="dtb-spacer"></div>

  <!-- Árbol de objetos -->
  <button class="dtb-btn" [class.dtb-active]="controller.objectTreeOpen$.value"
    (click)="toggleObjectTree()" title="Árbol de objetos">
    <i class="bi bi-list-nested"></i>
  </button>

  <!-- Más opciones (ocultar/bloquear/export/import) -->
  <div class="dtb-group">
    <button class="dtb-btn" [class.dtb-active]="showMorePanel"
      (click)="showMorePanel = !showMorePanel; showImportBox = false" title="Más opciones">
      <i class="bi bi-three-dots"></i>
    </button>
    <div class="dtb-flyout dtb-flyout-up" *ngIf="showMorePanel">
      <div class="dtb-fly-header">Dibujos</div>
      <button class="dtb-fly-item" (click)="controller.hideAll(); showMorePanel = false">
        <i class="bi bi-eye-slash"></i><span>Ocultar todos</span>
      </button>
      <button class="dtb-fly-item" (click)="controller.showAll(); showMorePanel = false">
        <i class="bi bi-eye"></i><span>Mostrar todos</span>
      </button>
      <button class="dtb-fly-item" (click)="controller.lockAll(); showMorePanel = false">
        <i class="bi bi-lock"></i><span>Bloquear todos</span>
      </button>
      <button class="dtb-fly-item" (click)="controller.unlockAll(); showMorePanel = false">
        <i class="bi bi-unlock"></i><span>Desbloquear todos</span>
      </button>
      <div class="dtb-fly-divider"></div>
      <button class="dtb-fly-item" (click)="exportToClipboard()">
        <i class="bi bi-clipboard"></i><span>Copiar JSON</span>
      </button>
      <button class="dtb-fly-item" (click)="showImportBox = !showImportBox">
        <i class="bi bi-clipboard-plus"></i><span>Importar JSON…</span>
      </button>
      <div class="dtb-import-box" *ngIf="showImportBox">
        <textarea [(ngModel)]="importJsonText" rows="4" placeholder="Pega aquí el JSON"></textarea>
        <button class="dtb-import-apply" (click)="importFromText()">Importar</button>
      </div>
    </div>
  </div>

  <!-- Eliminar todos -->
  <button class="dtb-btn dtb-danger" (click)="confirmClearAll()" title="Eliminar todos los dibujos">
    <i class="bi bi-trash"></i>
  </button>
</div>
